import angular from 'angular';

import {} from './rule-form.style.scss';

import WorkflowRuleFormController from './rule-form.controller';

export default angular.module('autoboard.monitoringEventForm', [])
  .controller('WorkflowRuleFormController', WorkflowRuleFormController)
  .name;
